import styled from 'styled-components'
import { CarouselProvider } from 'pure-react-carousel'

export const ImageElement = styled.img`
  max-width: 100%;
  max-height: var(--image-size, 100%);
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: grab;
  user-select: none;
  transition: transform 0.3s ease;
`

export const ImageWrapper = styled.div<{ $rotation: number }>`
  overflow: hidden;
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: var(--image-size, 100%);
  width: 100%;
  height: 100%;

  .iiz {
    width: 100%;
    height: 100%;
    max-height: var(--image-size, 100%);
    border-radius: 8px;
  }

  .iiz__img {
    width: 100%;
    height: 100%;
    max-height: var(--image-size, 100%);
    object-fit: contain;
    object-position: center;
  }
`

export const StyledCarouselProvider = styled(CarouselProvider)`
  width: 100%;
  height: 100%;

  .carousel__slider {
    width: 100%;
    height: 100%;
  }

  .carousel__inner-slide {
    justify-content: center;
    align-items: center;
    display: flex;
    max-height: var(--image-size, 100%);
  }

  .carousel__slide {
    width: 100%;
    height: 100%;
    max-height: var(--image-size, 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .carousel__image {
    max-width: 100%;
    max-height: var(--image-size, 100%);
    object-fit: contain;
    cursor: grab;
    user-select: none;

    &:active {
      cursor: grabbing;
    }
  }

  .carousel__slider-tray {
    height: 100%;
    max-height: var(--image-size, 100%);

    &-wrapper {
      height: 100%;
      max-height: var(--image-size, 100%);
    }
  }
`
